import React from 'react';
import { useIdioma } from '../../i18n/idioma';
import { ArrowRight, Sparkles } from 'lucide-react';

interface PricingNextStepCardProps {
  unpricedCount: number;
  nextItemLabel?: string;
  onShowNext: () => void;
  /** Tighter layout for the services sidebar. */
  variant?: 'document' | 'sidebar';
}

const PricingNextStepCard: React.FC<PricingNextStepCardProps> = ({
  unpricedCount,
  nextItemLabel,
  onShowNext,
  variant = 'document',
}) => {
    const { t } = useIdioma();
  if (unpricedCount <= 0) return null;

  const isSidebar = variant === 'sidebar';

  return (
    <div
      className={`rounded-2xl border border-acero-200 ${
        isSidebar ? 'px-3 py-3' : 'px-4 py-4 sm:px-5 sm:py-4'
      }`}
    >
      <div className="flex items-start gap-3">
        <div className="shrink-0 w-8 h-8 rounded-lg grid place-items-center bg-brand-100 text-brand-700">
          <Sparkles size={16} />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`font-semibold tracking-tight text-navy-950 ${isSidebar ? 'text-[13px]' : 'text-[15px]'}`}>
            {t('precios.siguiente.titulo')}
          </p>
          <p className={`text-acero-600 mt-1 leading-snug ${isSidebar ? 'text-[11px]' : 'text-xs sm:text-sm'}`}>
            <span className="font-data tabular-nums">{unpricedCount}</span>
            {unpricedCount === 1 ? t('precios.siguiente.pendiente') : t('precios.siguiente.pendientes')}
            {' — '}
            tap the yellow field{unpricedCount === 1 ? '' : 's'} on your estimate.
            {!isSidebar && t('precios.siguiente.seguardan')}
          </p>
          {nextItemLabel && (
            <p className={`mt-1.5 text-acero-500 truncate ${isSidebar ? 'text-[11px]' : 'text-[11px]'}`}>
              {t('precios.siguiente.sigue')} <span className="font-medium text-navy-950">{nextItemLabel}</span>
            </p>
          )}
          <button
            type="button"
            onClick={onShowNext}
            className={`mt-2.5 inline-flex items-center gap-1.5 font-medium text-navy-700 hover:text-navy-950 hover:underline underline-offset-4 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 rounded ${
              isSidebar ? 'text-[11px]' : 'text-xs sm:text-sm'
            }`}
          >
            {t('precios.siguiente.mostrar')}
            <ArrowRight size={isSidebar ? 12 : 14} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PricingNextStepCard;
